export default class SessionExpiredError extends Error {
  constructor() {
    super("");
    this.name = "SessionExpiredError";
  }
}
